import {observer} from "mobx-react-lite";
import React, {useCallback} from "react";
import {useStores} from "../hooks/useStores";
import KeyboardEventHandler from "react-keyboard-event-handler";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay, faPause, faStop} from '@fortawesome/free-solid-svg-icons';

export const GlobalTransport = observer(() => {

    const {modulatorsStore: modulators} = useStores();

    const keyboardHandler = useCallback(

        (key: any, e: any) => {
            e.preventDefault();
            // console.log(key);
            switch (key) {
                case 'backspace':
                case 'del':
                    modulators.stop();
                    break;
                case 'space':
                    if (modulators.running) {
                        modulators.pause();
                    } else {
                        modulators.play();
                    }
                    break;
                case 'enter':
                    break;
                case 's':
                    modulators.sync();
                    break;
                default:
                    // console.warn("missing handle for key", key);
            }
        }, [modulators]
    );

    return (
        <div className="global-transport">
            <button onClick={modulators.play} className={`button-play align-symbol ${modulators.running ? 'transport-active' : ''}`}><FontAwesomeIcon className={`${modulators.running ? 'animate-text' : ''}`} icon={faPlay} /></button>
            <button onClick={modulators.pause} className={`button-pause align-symbol ${modulators.paused ? 'transport-active' : ''}`}><FontAwesomeIcon className={`${modulators.paused ? 'animate-text' : ''}`} icon={faPause} /></button>
            <button onClick={modulators.stop} className="button-stop align-symbol"><FontAwesomeIcon icon={faStop} /></button>
{/*
            <button onClick={modulators.mute} className="button-mute space-left thin-button align-symbol"><FontAwesomeIcon icon={faVolumeMute} /></button>
            <button onClick={modulators.unmute} className="button-unmute thin-button align-symbol"><FontAwesomeIcon icon={faVolumeUp} /></button>
*/}
            <button onClick={modulators.sync} className="button-sync space-left">sync</button>
            <KeyboardEventHandler handleKeys={['backspace', 'del', 'enter', 'space', 's']} onKeyEvent={keyboardHandler} />
        </div>
    );

});
